import { useState } from "react";
import { AppContext, StepType } from "./app-context";

type AppProviderProps = {
  steps: StepType[];
  children: React.ReactNode;
};

export const AppProvider = ({ steps, children }: AppProviderProps) => {
  const [current, setCurrent] = useState(0);
  const [state, setState] = useState<Record<string, any>>({});

  const progress = ((current + 1) / steps.length) * 100;

  const go = (index: number) => {
    if (index < 0 || index >= steps.length) {
      return;
    }
    setCurrent(index);
  };

  const updateState = (key: string, value: any) => {
    setState((prevState) => ({ ...prevState, [key]: value }));
  };

  const contextValue = {
    steps,
    progress,
    current: {
      index: current,
      step: steps[current],
    },
    go,
    state,
    updateState,
  };

  return (
    <AppContext.Provider value={contextValue}>{children}</AppContext.Provider>
  );
};

export default AppProvider;
